import { render } from "./ServiceMatrix.vue?vue&type=template&id=a8ef552e&scoped=true"
import script from "./ServiceMatrix.vue?vue&type=script&lang=js"
export * from "./ServiceMatrix.vue?vue&type=script&lang=js"

import "./ServiceMatrix.vue?vue&type=style&index=0&id=a8ef552e&scoped=true&lang=css"
import "./ServiceMatrix.vue?vue&type=style&index=1&id=a8ef552e&scoped=true&lang=css"
import "./ServiceMatrix.vue?vue&type=style&index=2&id=a8ef552e&scoped=true&lang=css"
import "./ServiceMatrix.vue?vue&type=style&index=3&id=a8ef552e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ef552e"]])

export default __exports__